const isStringBase64 = (string = '') => {
  if (!string) return false

  return string.length % 4 == 0 && /^[A-Za-z0-9+/]+[=]{0,2}$/.test(string)
};
export default isStringBase64
  

